export default __webpack_public_path__ + "static/pink-bg-52c6eb80ba0037ca99b8557258ccfb77.png";